var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { School } from '@/models/School';
import { DateTime } from 'luxon';
import { identifyApplication, identifyHostname, isLocal } from '@/support/Client';
import { DeleteCurrentPLP } from '@/models/DeleteCurrentPLP';
import { DeleteFuturePLP } from '@/models/DeleteFuturePLP';
import axios from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { Generate } from '@/models/Generate';
import { Token } from '@/support/Token';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { GenerateStudentStatus } from '@/models/GenerateStudentStatus';
import { User } from '@/models/User';
import { LvsPeriod } from '@/models/LvsPeriod';
import { Group } from '@/models/Group';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import { RolesEnum } from '@/items/Roles';
let SchoolTools = class SchoolTools extends Vue {
    constructor() {
        super(...arguments);
        this.deleteBusyPLPModel = new DeleteCurrentPLP();
        this.deleteHighlightedPLPModel = new DeleteCurrentPLP();
        this.deleteOldPLPModel = new DeleteCurrentPLP();
        this.deleteCurrentPLPModel = new DeleteCurrentPLP();
        this.deleteFuturePLPModel = new DeleteFuturePLP();
        this.generateModel = new Generate();
        this.generateTime = '';
        this.hasStudents = false;
        this.isInitializingParnassys = false;
        this.isLoading = true;
        this.isLoadingGroups = false;
        this.isLoadingPeriods = false;
        this.isSyncingParnassys = false;
        this.isSyncingGoalsets = false;
        this.lvsGroups = [];
        this.studentGroup = '';
        this.lvsPeriods = [];
        this.studentStatusPeriod = '';
        this.syncTime = '';
        this.groupModel = new Group().limit(1000);
        this.clearSelects = false;
    }
    get syncDisabled() {
        if (this.syncTime.length === 0) {
            return false;
        }
        const syncStart = DateTime.fromISO(this.syncTime);
        const now = DateTime.local();
        if (now.diff(syncStart, 'minutes').as('minutes') > 5) {
            return false;
        }
        return true;
    }
    get dialogOptionsDeleteHighlighted() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.deleteHighlightedPLP').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.deleteHighlightedPLPModel.statusValue = ['highlighted'];
                        this.deleteHighlightedPLPModel
                            .create()
                            .then((response) => {
                            this.syncTime = DateTime.local().toString();
                        })
                            .catch((error) => {
                            if (!this.syncTime.length) {
                                this.syncTime = DateTime.local().toString();
                            }
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsDeleteOld() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.deleteOldPLP').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.deleteOldPLPModel.statusValue = ['old'];
                        this.deleteOldPLPModel
                            .create()
                            .then((response) => {
                            this.syncTime = DateTime.local().toString();
                        })
                            .catch((error) => {
                            if (!this.syncTime.length) {
                                this.syncTime = DateTime.local().toString();
                            }
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsDeleteBusy() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.deleteBusyPLP').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.deleteBusyPLPModel.statusValue = ['busy'];
                        this.deleteBusyPLPModel
                            .create()
                            .then((response) => {
                            this.syncTime = DateTime.local().toString();
                        })
                            .catch((error) => {
                            if (!this.syncTime.length) {
                                this.syncTime = DateTime.local().toString();
                            }
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsDeleteCurrent() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.deleteCurrentPLP').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.deleteCurrentPLPModel
                            .create()
                            .then((response) => {
                            this.syncTime = DateTime.local().toString();
                        })
                            .catch((error) => {
                            if (!this.syncTime.length) {
                                this.syncTime = DateTime.local().toString();
                            }
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsDeleteFuture() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.deleteFuturePLP').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.deleteFuturePLPModel
                            .create()
                            .then((response) => {
                            this.syncTime = DateTime.local().toString();
                        })
                            .catch((error) => {
                            if (!this.syncTime.length) {
                                this.syncTime = DateTime.local().toString();
                            }
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsPeriods() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.resetPeriods', { item: this.$t('dialogOptions.item.area') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        new Generate()
                            .resetPeriods()
                            .then(() => {
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsInitParnassys() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.init_warning').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.isInitializingParnassys = true;
                        new Generate()
                            .initParnassys()
                            .then(() => {
                            this.isInitializingParnassys = false;
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                            this.isInitializingParnassys = false;
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsLevels() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.resetLevels', { item: this.$t('dialogOptions.item.area') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        new Generate()
                            .resetLevels()
                            .then(() => {
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsGenerateSubjectStatuses() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('lvs.dialog.confirm.text', { item: this.studentStatusPeriod }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        new GenerateStudentStatus()
                            .create({ lvs_period: this.studentStatusPeriod, group: this.studentGroup })
                            .then(() => {
                            this.studentStatusPeriod = '';
                            this.studentGroup = '';
                            this.clearSelects = true;
                            this.$store.dispatch('openDialog', this.dialogOptionsStudentStatusPeriodSuccess);
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    get dialogOptionsStudentStatusPeriodSuccess() {
        return {
            title: this.$t('dialogOptions.success').toString(),
            text: this.$t('lvs.dialog.success.text').toString(),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
    get currentApplication() {
        return identifyApplication();
    }
    get canSyncTeachers() {
        return !!(this.school && this.school.parnassys && this.school.parnassys.can_sync_teachers);
    }
    get canSyncParents() {
        return !!(this.school && this.school.parnassys && this.school.parnassys.can_sync_guardians);
    }
    get canSyncStudents() {
        return !!(this.school && this.school.parnassys && this.school.parnassys.can_sync_students);
    }
    get user() {
        return this.$store.state.Auth;
    }
    get isTeacherWithExpertRights() {
        return this.user && this.user.isTeacherWithExpertRights();
    }
    get generateDisabled() {
        if (this.generateTime.length === 0) {
            return false;
        }
        const generateStart = DateTime.fromISO(this.generateTime);
        const now = DateTime.local();
        if (now.diff(generateStart, 'minutes').as('minutes') > 5) {
            return false;
        }
        return true;
    }
    generate() {
        this.generateModel
            .create()
            .then((response) => {
            this.syncTime = DateTime.local().toString();
        })
            .catch((error) => {
            if (!this.generateTime.length) {
                this.syncTime = DateTime.local().toString();
            }
            ErrorHandler.network(error);
        });
    }
    deleteBusy() {
        this.$store.dispatch('openDialog', this.dialogOptionsDeleteBusy);
    }
    deleteHighlighted() {
        this.$store.dispatch('openDialog', this.dialogOptionsDeleteHighlighted);
    }
    deleteOld() {
        this.$store.dispatch('openDialog', this.dialogOptionsDeleteOld);
    }
    deleteFuture() {
        this.$store.dispatch('openDialog', this.dialogOptionsDeleteFuture);
    }
    deleteCurrent() {
        this.$store.dispatch('openDialog', this.dialogOptionsDeleteCurrent);
    }
    dialogOptionsSyncParnassys(state) {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$t('dialogOptions.sync_warning').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.isSyncingParnassys = true;
                        new Generate()
                            .syncParnassys(state)
                            .then(() => {
                            this.isSyncingParnassys = false;
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                            this.isSyncingParnassys = false;
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    // public dialogOptionsSyncGoalsets(): Options {
    //   return {
    //     title: this.$t('dialogOptions.confirmation').toString(),
    //     text: this.$t('dialogOptions.sync_warning_goals_sets').toString(),
    //     type: 'warning',
    //     buttons: {
    //       confirm: {
    //         text: this.$t('dialogOptions.button.ok').toString(),
    //         action: () => {
    //           this.isSyncingGoalsets = true;
    //           new Generate()
    //             .syncGoalsets()
    //             .then(() => {
    //               this.isSyncingGoalsets = false;
    //             })
    //             .catch((error: AxiosError) => {
    //               ErrorHandler.network(error);
    //               this.isSyncingGoalsets = false;
    //             });
    //         },
    //       },
    //       cancel: {
    //         text: this.$t('dialogOptions.button.cancel').toString(),
    //       },
    //     },
    //   };
    // }
    mounted() {
        this.initialize();
        this.fetchLvsPeriods();
        this.fetchGroups();
    }
    initialize() {
        this.isLoading = true;
        this.generateModel.school = this.school.id;
        new User()
            .filter({ role: RolesEnum.STUDENT })
            .limit(1)
            .all()
            .then((response) => {
            this.hasStudents = !!response.length;
        });
        this.isLoading = false;
    }
    fetchLvsPeriods() {
        this.isLoadingPeriods = true;
        new LvsPeriod()
            .filter({ is_active: true })
            .all()
            .then((periods) => {
            this.lvsPeriods = periods;
            this.isLoadingPeriods = false;
        }).catch(() => {
            this.isLoadingPeriods = false;
        });
    }
    fetchGroups() {
        this.isLoadingGroups = true;
        new Group()
            .limit(1000)
            .all()
            .then((groups) => {
            this.lvsGroups = groups;
            this.isLoadingGroups = false;
        }).catch(() => {
            this.isLoadingGroups = false;
        });
    }
    resetPeriods() {
        this.$store.dispatch('openDialog', this.dialogOptionsPeriods);
    }
    resetLevels() {
        this.$store.dispatch('openDialog', this.dialogOptionsLevels);
    }
    generateSubjectStatuses() {
        this.$store.dispatch('openDialog', this.dialogOptionsGenerateSubjectStatuses);
    }
    syncParnassys(state) {
        this.$store.dispatch('openDialog', this.dialogOptionsSyncParnassys(state));
    }
    // protected syncGoalsets() {
    //   this.$store.dispatch('openDialog', this.dialogOptionsSyncGoalsets());
    // }
    initParnassys() {
        this.$store.dispatch('openDialog', this.dialogOptionsInitParnassys);
    }
    downloadFileBlob() {
        const API = `${identifyHostname()}`;
        const headers = {
            "Accept": 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Content-type': 'application/json',
        };
        if (isLocal()) {
            headers['X-Application'] = identifyApplication();
        }
        if (Token.getAccessToken()) {
            headers.Authorization = `Bearer ${Token.getAccessToken()}`;
        }
        const client = axios.create({
            baseURL: API,
            headers,
            responseType: 'blob',
        });
        client
            .get('/v3/statistics')
            .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'statistics.xlsx');
            document.body.appendChild(link);
            link.click();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof School !== "undefined" && School) === "function" ? _a : Object)
], SchoolTools.prototype, "school", void 0);
SchoolTools = __decorate([
    Component({
        components: {
            PageHeader,
            LoaderCard,
            AsyncSelect,
        },
    })
], SchoolTools);
export default SchoolTools;
